"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { Period } from "@/helpers/Types";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import CreateWaveDatesEndDateSelectPeriod from "../dates/end-date/CreateWaveDatesEndDateSelectPeriod";
import { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
export default function CreateWaveApprovalThresholdTime(t0) {
  const $ = _c(57);
  const {
    thresholdTimeError,
    thresholdDurationError,
    setThresholdTimeMs
  } = t0;
  const [time, setTime] = useState(null);
  const [period, setPeriod] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      const newTime = parseInt(e.target.value);
      const isValid = !isNaN(newTime) && newTime > 0;
      setTime(isValid ? newTime : null);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onTimeChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = newPeriod => {
      setPeriod(newPeriod);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const onPeriodSelect = t2;
  let t3;
  if ($[2] !== period || $[3] !== time) {
    t3 = () => {
      if (!time || !period) {
        return null;
      }
      const now = new Date();
      const currentMillis = now.getTime();
      bb19: switch (period) {
        case Period.MINUTES:
          {
            now.setMinutes(now.getMinutes() + time);
            break bb19;
          }
        case Period.HOURS:
          {
            now.setHours(now.getHours() + time);
            break bb19;
          }
        case Period.DAYS:
          {
            now.setDate(now.getDate() + time);
            break bb19;
          }
        case Period.WEEKS:
          {
            now.setDate(now.getDate() + time * 7);
            break bb19;
          }
        case Period.MONTHS:
          {
            now.setMonth(now.getMonth() + time);
            break bb19;
          }
        default:
          {
            assertUnreachable(period);
          }
      }
      return now.getTime() - currentMillis;
    };
    $[2] = period;
    $[3] = time;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getMillis = t3;
  let t4;
  if ($[5] !== thresholdDurationError || $[6] !== thresholdTimeError || $[7] !== time) {
    t4 = () => thresholdTimeError && !time || thresholdDurationError;
    $[5] = thresholdDurationError;
    $[6] = thresholdTimeError;
    $[7] = time;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const getTimeError = t4;
  let t5;
  if ($[9] !== period || $[10] !== thresholdDurationError || $[11] !== thresholdTimeError) {
    t5 = () => {
      if (!thresholdTimeError) {
        return [];
      }
      if (!thresholdDurationError && !period) {
        return [CREATE_WAVE_VALIDATION_ERROR.END_DATE_REQUIRED];
      }
      return [];
    };
    $[9] = period;
    $[10] = thresholdDurationError;
    $[11] = thresholdTimeError;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const getPeriodError = t5;
  let t6;
  if ($[13] !== getTimeError) {
    t6 = getTimeError();
    $[13] = getTimeError;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const [timeError, setTimeError] = useState(t6);
  let t7;
  if ($[15] !== getPeriodError) {
    t7 = getPeriodError();
    $[15] = getPeriodError;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const [periodErrors, setPeriodErrors] = useState(t7);
  let t8;
  if ($[17] !== getPeriodError || $[18] !== getTimeError) {
    t8 = () => {
      setTimeError(getTimeError());
      setPeriodErrors(getPeriodError());
    };
    $[17] = getPeriodError;
    $[18] = getTimeError;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== thresholdDurationError || $[21] !== thresholdTimeError || $[22] !== time) {
    t9 = [thresholdTimeError, thresholdDurationError, time];
    $[20] = thresholdDurationError;
    $[21] = thresholdTimeError;
    $[22] = time;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  useEffect(t8, t9);
  let t10;
  if ($[24] !== getMillis || $[25] !== setThresholdTimeMs) {
    t10 = () => {
      setThresholdTimeMs(getMillis());
    };
    $[24] = getMillis;
    $[25] = setThresholdTimeMs;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== period || $[28] !== time) {
    t11 = [time, period];
    $[27] = period;
    $[28] = time;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  useEffect(t10, t11);
  let t12;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="tw-mb-0 tw-text-lg  sm:tw-text-xl tw-font-semibold tw-text-iron-50">Select time</p>;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== time) {
    t13 = time !== null ? time.toString() : "";
    $[31] = time;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const t14 = `${timeError ? "tw-ring-error focus:tw-border-error focus:tw-ring-error tw-caret-error" : "tw-border-iron-650 tw-ring-iron-650  focus:tw-border-blue-500 tw-caret-primary-400 focus:tw-ring-primary-400"} tw-form-input tw-pb-3 tw-pt-4 tw-pl-10 tw-pr-4 tw-text-base tw-block tw-w-full tw-rounded-lg tw-border-0 tw-appearance-none ${time ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-font-medium tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <input type="string" value={t13} onChange={onTimeChange} id="dates-end-time" autoComplete="off" className={t14} placeholder=" " />;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const t16 = `${timeError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-text-base tw-text-iron-500 tw-absolute tw-cursor-text tw-font-medium tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-ml-7 tw-px-2 peer-focus:tw-px-2 peer-placeholder-shown:tw-scale-100 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t17;
  if ($[36] !== t16) {
    t17 = <label htmlFor="dates-end-time" className={t16}>Set time</label>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const t18 = `${timeError ? "tw-text-error" : "tw-text-iron-300 "} tw-w-5 tw-h-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out`;
  let t19;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <path d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t18) {
    t20 = <div className="tw-pointer-events-none tw-absolute tw-flex tw-items-center tw-inset-y-0 tw-pl-3"><svg className={t18} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t19}</svg></div>;
    $[39] = t18;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t15 || $[42] !== t17 || $[43] !== t20) {
    t21 = <div className="tw-relative">{t15}{t17}{t20}</div>;
    $[41] = t15;
    $[42] = t17;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== thresholdDurationError || $[46] !== timeError) {
    t22 = timeError && <div className="tw-mt-1.5 tw-text-error tw-text-xs tw-font-medium"><div className="tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>{thresholdDurationError ? "Threshold duration can't be longer than wave duration" : "Please set time"}</span></div></div>;
    $[45] = thresholdDurationError;
    $[46] = timeError;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t21 || $[49] !== t22) {
    t23 = <div>{t21}{t22}</div>;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== period || $[52] !== periodErrors) {
    t24 = <CreateWaveDatesEndDateSelectPeriod activePeriod={period} errors={periodErrors} onPeriodSelect={onPeriodSelect} />;
    $[51] = period;
    $[52] = periodErrors;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = <div className="tw-mt-8 tw-col-span-full">{t12}<div className="tw-mt-3 tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-4">{t23}{t24}</div></div>;
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  return t25;
}